import { combineEpics } from 'redux-observable';
import calculationDataEpic from './calculation-data';
import loadingEpic from './loading-epic';
import getTemplateData from './get-template-data';

export const rootEpic = combineEpics(
    ...calculationDataEpic,
    ...getTemplateData,
    ...loadingEpic
);
